import './HomepageImage.css'
import { useEffect, useRef } from 'react'
import { TweenMax } from 'gsap';
import { Tween } from 'gsap/gsap-core';
import anime from 'animejs';
import { useTranslation } from 'react-i18next';

function HomepageImage() {

    const header = useRef(null)
    const headerText = useRef(null)
    const headerSecondText = useRef(null)

    const { t } = useTranslation()

    useEffect(() => {
        anime({
            targets: header.current,
            translateY: ["1000px", "0px"],
            opacity: [0, 1],
            duration: 2000,
            easing: 'easeOutExpo',
            delay: (el, i) => 500 + 60 * 1
        });
        anime({
            targets: [headerSecondText.current, headerText.current],
            opacity: [0, 1],
            display: ['none', 'block'],
            duration: 2500,
            easing: 'easeOutExpo',
            delay: 1500
        });
    }, []);

    return (

        <div className="image-container w-100">
            <div className="container-lg">
                <div>
                    <h1 ref={header}>KAM-TECH</h1>
                    <h2 id='headerText' ref={headerText}>{t("homepageimage.text1")}</h2>
                </div>
                <h2 id='headerSecondText' ref={headerSecondText}>{t("homepageimage.text2")}</h2>
            </div>
            <img src="images/zamek4k.jpeg" alt="Zamek w Stobnicy" />
        </div>

    )

}
export default HomepageImage